import React from "react";
import PropTypes from "prop-types";
import { Link } from "./little_router";

class ActiveLink extends React.Component {
  render () {
    const classNames = (this.props.className || {});
    const activeProps = { className: "active " + classNames };
    const p = Object.assign({}, this.props, { activeProps: activeProps });
    return (
      <Link {...p} />
    );
  }
}

ActiveLink.propTypes = {
  className: PropTypes.string
};

export default ActiveLink;
